'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _Button = require('../../../../components/buttons/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _NotificationPopup = require('./NotificationPopup');

var _NotificationPopup2 = _interopRequireDefault(_NotificationPopup);

var _CountIndicator = require('../../../../components/misc/CountIndicator');

var _CountIndicator2 = _interopRequireDefault(_CountIndicator);

var _popupActions = require('../../../../components/popupPanel/popupActions');

var _userService = require('../../../../user/userService');

var _notificationActions = require('../../../../notifications/notificationActions');

var _boardService = require('../../../../element/board/boardService');

var _notificationUtilSelector = require('./notificationUtilSelector');

var _notificationUtilSelector2 = _interopRequireDefault(_notificationUtilSelector);

var _analytics = require('../../../../analytics');

require('../HeaderUtil.scss');

require('./NotificationUtil.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Styles


// Actions


// Components
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        openPopupPanel: function openPopupPanel() {
            dispatch((0, _popupActions.togglePopup)('notification'));
            (0, _analytics.analyticsEvent)('viewed-notifications');
        },
        fetchModified: function fetchModified() {
            return dispatch((0, _notificationActions.fetchModifiedBoards)());
        },
        fetchNotificationUsers: function fetchNotificationUsers(users) {
            return dispatch((0, _userService.fetchUsers)(users));
        },
        fetchNotificationBoards: function fetchNotificationBoards(boardIds) {
            return dispatch((0, _boardService.fetchBoards)({ boardIds: boardIds, loadAncestors: false }));
        }
    };
}; // Lib


var NotificationUtil = function NotificationUtil(props) {
    var isGuest = props.isGuest,
        openPopupPanel = props.openPopupPanel,
        notificationsCount = props.notificationsCount,
        popupOpen = props.popupOpen,
        notificationsReady = props.notificationsReady;

    // don't show notifications for guest user

    if (isGuest) return null;

    return _react2.default.createElement(
        'div',
        { className: 'HeaderUtil' },
        _react2.default.createElement(
            _Button2.default,
            { className: 'NotificationUtil highlight', onClickFn: openPopupPanel },
            _react2.default.createElement(_Icon2.default, { name: 'nav-notifications' }),
            _react2.default.createElement(_CountIndicator2.default, { count: notificationsCount, hide: popupOpen || !notificationsReady, badge: true })
        ),
        _react2.default.createElement(_NotificationPopup2.default, null)
    );
};

NotificationUtil.propTypes = {
    popupOpen: _propTypes2.default.bool,
    isGuest: _propTypes2.default.bool,
    openPopupPanel: _propTypes2.default.func,
    children: _propTypes2.default.element,
    notifications: _propTypes2.default.object,
    activeNotifications: _propTypes2.default.object,
    notificationsCount: _propTypes2.default.number,
    currentUser: _propTypes2.default.object,
    fetchedTime: _propTypes2.default.number,
    forcedPoll: _propTypes2.default.number,
    fetchNotificationUsers: _propTypes2.default.func,
    fetchNotificationBoards: _propTypes2.default.func,
    fetchModified: _propTypes2.default.func,
    markBoardsAsSeen: _propTypes2.default.func,
    notificationUserIds: _propTypes2.default.array,
    notificationsReady: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(_notificationUtilSelector2.default, mapDispatchToProps)(NotificationUtil);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/notifications/NotificationUtil.js
// module id = 2186
// module chunks = 0